import menu from 'antd/es/menu';
import { v1 } from 'uuid';
import { request } from './request';

// 获取节点
export const getNode = async (params = {}, options = {}) => {
    const data = await request.get('/console/v1/node/config', params, options);

    return data;
};

//  节点列表
export const getNodeList = async (params = {}, options = {}) => {
    const data = await request.get('/console/v1/node/menu', params, options);

    return data;
};

//  删除节点
// export const delNode = async (params = {}, options = {}) => {
//     const data = await request.post('/device/del_node', params, options);

//     return data;
// };

// // 编辑节点
// export const editNode = async (params = {}, options = {}) => {
//     const data = await request.post('/device/edit_node', params, options);

//     return data;
// };

export const editNodeName = async (params = {}, options = {}) => {
    const data = await request.post('/console/v1/node/name', params, options);

    return data;
};
